import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { PlusOutlined } from "@ant-design/icons";

import { Input, InputGroup, InputNumber, RadioGroup, Select } from "components/form";
import { DatePicker as AntdDatePicker, Flex, Row, Space, Button, Modal, Form, Col, DatePicker, List } from "antd";
import EmployeeWorkInTimestampTable from "components/table/EmployeeWorkInTimestampTable";
import { useSelector } from "react-redux";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import { Formik } from "formik";
import Dragger from "antd/es/upload/Dragger";
import { useState } from "react";
import { Alert } from "components/elements";
import { ReactComponent as UploadIcon } from "../../../assets/icon/uploadIcon.svg";

function EmployeeWorkInTimestamp({
  pagination = {},
  isLoading = false,
  timestampList = [],
  initialValues = {},
  isModalOpen = false,
  onSubmit = () => { },
  onChange = () => { },
  onCreate = () => { },
  onCancel = () => { },
  onDownload = () => { },
  onEndDateChange = () => { },
  onStartDateChange = () => { },
  handleDateChange = () => { },
  handleApply = () => { }
}) {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const [fileList, setFileList] = useState([])
  const { RangePicker } = DatePicker;

  function formatDate(dateString, pattern = "DD-MM-YYYY HH:mm") {
    return "DD-MM-YYYY HH:mm";
  }
  function fileSize(item) {
    if (item.size / 1000000 > 1) {
      return (item.size / 1000000) + " mb"
    } else if (item.size / 1000 > 1) {
      return (item.size / 1000) + " kb"
    } else {
      return item.size + " byte"
    }
  }

  function xlsxIcon() {
    return <svg width="30" height="30" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.4843 1.84619H9.84619V3.6825H11.7114V4.93235H9.84619V6.15388H11.6923V7.38465H9.84619V8.61542H11.6923V9.84619H9.84619V11.077H11.6923V12.3077H9.84619V14.1539H15.4843C15.768 14.1539 16 13.9133 16 13.6185V2.38158C16 2.08681 15.768 1.84619 15.4843 1.84619ZM14.7693 12.3077H12.3077V11.077H14.7693V12.3077ZM14.7693 9.84619H12.3077V8.61542H14.7693V9.84619ZM14.7693 7.38465H12.3077V6.15388H14.7693V7.38465ZM14.7693 4.92311H12.3077V3.69235H14.7693V4.92311Z" fill="#1E6E42" />
      <path d="M0 1.77785V14.2228L9.23077 16V0L0 1.77785ZM5.83877 11.1262L4.76492 9.096C4.72431 9.02031 4.68246 8.88123 4.63877 8.67877H4.62215C4.60185 8.77415 4.55385 8.91938 4.47815 9.11385L3.40062 11.1262H1.72738L3.71385 8.00985L1.89662 4.89292H3.60492L4.496 6.76185C4.56554 6.90954 4.62769 7.08492 4.68308 7.28738H4.70031C4.73538 7.16554 4.80062 6.98462 4.896 6.744L5.88677 4.89231H7.45108L5.58215 7.98277L7.50338 11.1255L5.83877 11.1262Z" fill="#1E6E42" />
    </svg>

  }
  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Modal
        destroyOnClose
        title={
          initialValues?.id ? t('common.edit') : t('common.create')
        }
        open={isModalOpen}
        onCancel={() => {
          const cancelBtn = document.getElementById(
            "cancelBtn"
          );
          if (cancelBtn) {
            cancelBtn.click();
          } else {
            onCancel();
          }
        }}
        footer={null}
        width={"30%"}
        closable={false}
        maskClosable={false}
      >
        <Formik
          enableReinitialize
          initialValues={{ ...initialValues, }}
          onSubmit={onSubmit}
        // validationSchema={schema}
        >
          {({ values = {}, submitForm, setFieldValue }) => {

            return (
              <Form onFinish={submitForm}>
                {/* <Divider /> */}
                <Row gutter={[24, 16]}>
                  <Col span={24}>
                    <Flex>
                      <span style={{ color: "#667085" }}>{t('holiday.label.date')}</span>
                    </Flex>
                    <DatePicker
                      name="checkInDateTime"
                      label={t('date-of-birth')}
                      placeholder={t('dd-mm-yyyy')}
                      // size="large"
                      showTime
                      // onChange={(e) => {
                      //   console.log("ee", e);
                      //   const date2 = dayjs();

                      //   let years = date2.diff(e, 'year');
                      //   setFieldValue('age', years)

                      // }}
                      format={formatDate()}
                    />
                  </Col>
                  <Col span={24}>
                    <Input
                      name="detail"
                      label={t('policy.label.detail')}
                      placeholder={t('policy.label.detail')}
                      size="small"
                      type="textarea"
                    />
                  </Col>
                  <Col span={24}>
                    <Flex>
                      <span style={{ color: "#667085" }}>{t('employee.label.attachment-file')}</span>
                    </Flex>
                    <Dragger
                      fileList={fileList}
                      type="drag"
                      maxCount={1}
                      listType="picture"
                      showUploadList={true}
                      style={{ backgroundColor: "white", borderRadius: "12px" }}
                      onDrop={(e) => {
                        console.log("onDrop", e);
                      }}
                      itemRender={(e, file, fileList, action) => {
                        console.log("itemRender", e, file, fileList, action);
                        return <List dataSource={fileList}
                          renderItem={(item) => (
                            <List.Item key={1}>
                              <List.Item.Meta
                                avatar={xlsxIcon()}
                                title={item.name}
                                description={fileSize(item)}
                              />
                              <Button style={{
                                border: "transparent"
                              }} icon={"x"} onClick={() => { action.remove() }} >
                                {/* {t('whiteList..download')} */}
                              </Button>
                            </List.Item>
                          )}
                        />
                      }}
                      beforeUpload={(info) => {
                        return false;
                      }

                      }
                      onChange={(info) => {
                        console.log("info", info);
                        if (info.file?.name && !info.file?.name?.endsWith("xlsx")) {
                          Alert({ type: "error", message: "ระบบรองรับไฟล์ xlsx", noti: true })
                          setFileList([])
                        } else if (info.file?.name) {
                          console.log("info?.file", info?.file);
                          setFileList([info?.file])
                        }
                      }}
                      onRemove={() => {
                        console.log("onRemove");
                        setFileList([])
                      }}
                    >          <Flex style={{
                      height: "20vh",
                      rowGap: "14px"
                    }} vertical justify="center" align="center">
                        <Flex style={{ width: "10%" }} ><UploadIcon /></Flex>
                        <Flex>
                          <span style={{ color: "#2CADE7", fontWeight: "bold" }}>{t("common.choose_file")}</span>
                          &nbsp;
                          <span style={{ color: "#475467" }}>{t("common.upload_dnd")}</span>
                        </Flex>

                      </Flex>
                    </Dragger>
                  </Col>
                  <Col span={24}>
                  </Col>


                </Row>
                <Row justify="end" style={{ paddingTop: "20px" }}>
                  <Space direction="horizontal" size={12}>
                    <Button
                      id="cancelBtn"
                      type="default"
                      onClick={() => {
                        onCancel();
                      }}
                      style={{ borderRadius: 8, padding: "8px 16px", height: "40px" }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button htmlType="submit"
                      type="primary"
                      style={{ borderRadius: 8, padding: "8px 16px", height: "40px", backgroundColor: "var(--button-color)" }}
                    >
                      {t("common.submit").toUpperCase()}
                    </Button>
                  </Space>
                </Row>
              </Form>
            );
          }}
        </Formik>

      </Modal>
      <Flex justify="space-between">
        {/* <Space direction="horizontal" size={6}>
          <AntdDatePicker
            defaultValue={dayjs()}
            onChange={onStartDateChange}
            disabledDate={(currentDate) =>
              currentDate.isBefore(dayjs("2024-01-01"))
            }
            size="large"
            format={i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB"}
          />
          <p>-</p>
          <AntdDatePicker
            defaultValue={dayjs()}
            onChange={onEndDateChange}
            disabledDate={(currentDate) =>
              currentDate.isBefore(dayjs("2024-01-01"))
            }
            size="large"
            format={i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB"}
          />
        </Space> */}

        <Flex gap={16} align="end">
          <Flex vertical>
            <label>{t("workin.label.date_employed")}</label>
            <RangePicker
              name="employedStartDate"
              placeholder={[t("workin.label.date_employed"), ""]}
              defaultValue={[dayjs().startOf('month'), dayjs()]}
              format={i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB"}
              onChange={handleDateChange}
              disabledDate={(currentDate) => currentDate.isBefore(dayjs("2024-01-01"))}
              size="large"
            />
          </Flex>

          <Button type="default" onClick={handleApply}
            style={{ height: "40px", borderRadius: "8px" }} size="large">
            {t("translation.search")}
          </Button>
        </Flex>

        <Space direction="horizontal" size={12} align="end">
          <Button type="default" disabled={isLoading} onClick={onDownload}
            style={{ height: "40px", borderRadius: "8px" }}
          >
            <Flex align="center" justify="center" gap={8}>
              <DownloadIcon />
              <span style={{ color: "#667085", fontWeight: "bold" }}>{t('common.download')}</span>
            </Flex>
          </Button>
          {roles.includes("CREATE_EMPLOYEE|WORK_IN|TIME_STAMP") &&
            <Button onClick={onCreate} type="primary"
              style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}
            >
              <Flex align="center" justify="center" gap={8}>
                <CreateIcon />
                {t("common.create")}
              </Flex>
            </Button>
          }

        </Space>
      </Flex>
      <EmployeeWorkInTimestampTable
        isLoading={isLoading}
        dataSource={timestampList}
        pagination={pagination}
        onChange={onChange}
      />
    </Space >
  );
}

export default EmployeeWorkInTimestamp;
